import React, { useState } from "react";
import { useQuery } from "react-query";
import Loading from "../Shared/Loading";
import ProductDeleteModel from "./ProductDeleteModel";
import ProductRow from "./ProductRow";

const AllProducts = () => {
  const [modalData, setModalData] = useState({});
  const [showProductDeleteModal, setShowProductDeleteModal] = useState(false);

  const {
    data: allProducts,
    isLoading,
    refetch,
  } = useQuery("allProducts", () =>
    fetch("https://evening-peak-35730.herokuapp.com/products").then((res) => {
      return res.json();
    })
  );

  if (isLoading) {
    return <Loading></Loading>;
  }
  return (
    <div>
      <h1 className="text-xl text-accent text-center my-4 font-bold">
        All Products List
      </h1>
      <div className="overflow-x-auto">
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>#</th>
              <th>Product's Image</th>
              <th>Product's Name</th>
              <th>Product In Stock</th>
              <th>Product's Price</th>
              <th>Brand's Slug</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {allProducts.map((product, index) => (
              <ProductRow
                key={product._id}
                product={product}
                index={index}
                setModalData={setModalData}
                setShowProductDeleteModal={setShowProductDeleteModal}
              ></ProductRow>
            ))}
          </tbody>
        </table>
      </div>
      {showProductDeleteModal && (
        <ProductDeleteModel
          product={modalData}
          refetch={refetch}
          setShowProductDeleteModal={setShowProductDeleteModal}
          setModalData={setModalData}
        ></ProductDeleteModel>
      )}
    </div>
  );
};

export default AllProducts;
